import React, { useState, useEffect, useRef, KeyboardEvent, MouseEvent } from 'react';
import { unstable_batchedUpdates } from 'react-dom';

import Inactive from './Inactive.js';
import db from './firebase.config.js';
import Navbar from './navbar.js';
import { resolveSessionDocId, sessionDocRef } from './sessionId.js';
import { initializePassengerVisit } from './passengerConnection';
import useSpotifyConnection from './useSpotifyConnection';
import Remote from './Remote.js';
import RemoteTabs from './Tab.js';
import RideEnded from './RideEnded.js'
import JoinScreen from './JoinScreen';
import PresenceCheck, { PresenceRecheckNotice } from './PresenceCheck';
import usePassengerPresence from './usePassengerPresence';
import { PRESENCE_VIEW, inLockGrace, ownPresenceEntry, showsRemote } from './presenceState';
import { isLocationDenied, locationHelpDue, nextLocationMisses, startLocationHeartbeat } from './locationHeartbeat';

import { useSelector, useDispatch } from 'react-redux'

import { useCookies } from 'react-cookie';

import FingerprintJS from '@fingerprintjs/fingerprintjs'

import firebase from 'firebase/app';
import "firebase/firestore";

import './main.css'


function Lookup({ match }) {
    const [cookies, setCookie] = useCookies(['location_granted', 'access_token', 'refresh_token', 'passenger_id', 'session_id', 'guest_pax_name', 'qr_id']);

    const qr_id = match.params.qr_id || cookies.qr_id; 
    const location_granted_cookie = cookies.location_granted === true || cookies.location_granted === 'true'


    const [uidFetched, setFetched] = useState(false)
    const [firstLoad, setFirstLoad] = useState(false)
    const [uid, setUID] = useState("")
    const [start, setStart] = useState(-1) //driver session ID
    // resolved Sessions/<uid>/sessionData/<id>, only valid for the start it was resolved from
    const [sessionDoc, setSessionDoc] = useState({ start: -1, id: '' })
    const sessionLookup = useRef(0)
    const sessionDocId = sessionDoc.start === start ? sessionDoc.id : ''

    const [snapshots, setSnapshots] = useState(0)

    const [location, setLocation] = useState({});
    const [speed, setSpeed] = useState();
    const [driver_accuracy, setDriverAccuracy] = useState();
    const [paxLong, setPaxLong] = useState();
    const [paxLat, setPaxLat] = useState();
    const [driverPaxProximity, setDriverPaxProximity] = useState(false);
    const [driverPaxQueue, setDriverPaxQueue] = useState(true);
    const [driverPaxVolume, setDriverPaxVolume] = useState(true);
    const [alias, setAlias] = useState("");
    const [og_idx, setOGIDX] = useState(-1);
    const [pax_queued_idx, setQueueIDX] = useState(-1);

    const [driverLong, setDriverLong] = useState();
    const [driverLat, setDriverLat] = useState();

    const [driverTips, setDriverTips] = useState({});


    const [name, setName] = useState('')
    const [refreshToken, setRefreshToken] = useState('')
    const [status, setUserStatus] = useState(true)

    const [CDN, setCDN] = useState("https://i.scdn.co/image/ab67616d0000b273148e1f0715c7e9c1034d722c")
    const [trackName, setTrackName] = useState("Song A");
    const [last_queued_song, setLastQueued] = useState("")
    const [track_url, setTrackURL] = useState("");
    const [artist_name, setArtistName] = useState("Artist A");

    const [pax_sesh_id, setPaxSeshID] = useState("");
    const [passenger_id, setPassengerID] = useState("");
    const [pax_guest_name, setPaxGuestName] = useState("");
    const [pax_queue, setPaxQueue] = useState({});
    const [live_pax, setLivePax] = useState({})
    const [circle_delay, setCircleDelayDB] = useState(false);
    const [driverDocLoaded, setDriverDocLoaded] = useState(false)
    const [locationWriteAt, setLocationWriteAt] = useState(null)
    const heartbeatRef = useRef(null)
    const [locationMisses, setLocationMisses] = useState(0) // beats in a row without a fix
    const [locationRetrying, setLocationRetrying] = useState(false)
    const ownEntry = ownPresenceEntry(live_pax, passenger_id)
    // Read the grant from the entry too: the per-pax effect sets driverPaxProximity a render late.
    const driverOverride = driverPaxProximity || (ownEntry?.driver_secret === true && !('expired' in ownEntry))
    const presence = usePassengerPresence({
        active: status, loaded: driverDocLoaded, passengerId: passenger_id, livePax: live_pax,
        override: driverOverride, writeSettledAt: locationWriteAt, driverUid: uid, sessionStart: start,
        requestFreshPosition: () => heartbeatRef.current && heartbeatRef.current.pushNow('lock_check'),
    })
    const paxProximity = presence.paxProximity

    const location_granted = useSelector(state=> state.location_granted)
    const coords = useSelector(state=> state.coords)
    const pax_redux_refresh = useSelector(state=> state.pax_refresh)

    const prev_song = useSelector(state => state.song);

    const pax_access_cookie = cookies.access_token || "NO_ACCESS"
    const passenger_id_cookie = cookies.passenger_id || "" // fingerprint prior to spot auth
    const session_id_cookie = cookies.session_id || "" // fingerprint prior to spot auth

    const guest_pax_name = cookies.guest_pax_name || ""


    const [drawer, setDrawer] = useState(false)
    const [anchor, setAnchor] = useState('right')
    const fin_anchor = "right";
    
    const geoSettings = {
        enableHighAccuracy: true,
        timeout: 15000, // a hung fix becomes a miss instead of stacking 20 s requests
        maximumAge: 0,
    };

    
    const toggleDrawer = (anchor, open) => () => {
        // setState({ ...state, [anchor]: open });
        setDrawer(open);
      };


    const dispatch = useDispatch()

    const locSuccess = position => {
        const { latitude, longitude } = position.coords;
        setLocationMisses(misses => nextLocationMisses(misses, null))
        setLocationRetrying(false)

        setLocation({
            latitude, longitude
        });

        

        try {
            // const latitude = position.coords.latitude;
            // const longitude = position.coords.longitude;
            setPaxLat(latitude)
            setPaxLong(longitude)
            // console.error('successfully in locSuccess:', latitude);

          } catch (err) {
            console.error('Error in locSuccess:', err);
          }

        // if(passenger_id != "") { 
        //     db.collection('Users').doc(uid).update({
        //         // ['currentSession.location.pax_latitude'] : latitude,
        //         // ['currentSession.location.pax_longitude']: longitude,
        //         // ['currentSession.location.pax_update_time']: firebase.firestore.FieldValue.serverTimestamp(),
        //         // ['currentSession.location.pax_accuracy']: position.coords.accuracy,
        //         ['live_pax_coords.'+passenger_id+'.latitude'] : latitude,
        //         ['live_pax_coords.'+passenger_id+'.longitude'] : latitude,
        //         ['live_pax_coords.'+passenger_id+'.pax_update_time']: firebase.firestore.FieldValue.serverTimestamp(),
        //         ['live_pax_coords.'+passenger_id+'.pax_accuracy']: position.coords.accuracy,
    
                
        //     })
        // }else{
        //     console.log("no pax id yet in locsuccess " + passenger_id)

        // }
        
        console.log("location successfully fetched for " + passenger_id)

        setCookie('location_granted', (location_granted || Boolean(location_granted_cookie)), { path: '/' });

        //just in case pax turn off loc_services after initial auth :D
        dispatch({ type: 'Location_Error_Reset' })
        dispatch({ type: 'Location_Request_Granted' })
        dispatch({ type: 'Pax_Coords_Update', payload: {coords: [latitude, longitude]} })

        return [latitude, longitude]
    };

    function locError(err) {
        if (!isLocationDenied(err)) {
            // Unavailable/timeout: keep presence and the permission cookie; the next beat retries.
            console.log("location beat skipped", err && err.code, err && err.message)
            setLocationMisses(misses => nextLocationMisses(misses, err))
            setLocationRetrying(false)
            return
        }
        dispatch({ type: 'Location_Request_Declined' })
        setCookie('location_granted', false, { path: '/' });
        dispatch({ type: 'Location_Error_Denied' })
        console.log("LIVE location Blocked initi" + location_granted)

        console.log("error!");
        console.log(err);

    }

    // START GEO Location verification of passenger
    function getDistanceFromLatLonInKm(lat1,lon1,lat2,lon2) {
        var R = 6371; // Radius of the earth in km
        var dLat = deg2rad(lat2-lat1);  // deg2rad below
        var dLon = deg2rad(lon2-lon1); 
        var a = 
          Math.sin(dLat/2) * Math.sin(dLat/2) +
          Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * 
          Math.sin(dLon/2) * Math.sin(dLon/2)
          ; 
        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)); 
        var d = R * c; // Distance in km
        return d;
      }
      
      function deg2rad(deg) {
        return deg * (Math.PI/180)
      }
    


    // START QR_ID to Driver UID lookup
    async function getDriverUID(qr_id) {
        const cap_qr = qr_id.toUpperCase()
        try {
            console.log("trying getDriver again w/ ", cap_qr)
            const driverRef = db.collection('Lookup').doc(cap_qr);
            const id_snap = await driverRef.get();

            const tmp_uid = id_snap.data().uid
            if(tmp_uid == ""){
                alert("Notify your driver to finish setting up Strive")                 
            }else{
                setUID(tmp_uid)
                console.log("god uid w/ ", tmp_uid)

                setFetched(true)
                
                return tmp_uid
            }

        } catch (e) {
            alert("Couldn't find driver's ID - Notify your driver to finish setting up in Strive.FM App") 
            console.log(e) 
        }
    }

    async function getPassengerFingerprint() {
        try {
            const fpPromise = FingerprintJS.load({
                token: 'baxubysPJyzkkUyEEZUl'
            })
            const fp = await fpPromise
            const result = await fp.get()

            // This is the visitor identifier:
            const passenger_id = result.visitorId
            setPassengerID(passenger_id)

            return passenger_id;

        } catch (e) { console.log(e) }
    }

    function fetch_guest_name(){
        var live_count = Object.keys(live_pax).length
        return "guest" + live_count
    }

    useEffect(()=>{
        if(pax_queue != []){
            dispatch({type: 'Pax_Queue', payload: {pax_queue: pax_queue}})
        }
    }, [pax_queue])

    useEffect(()=>{
        if(driverTips!={} && Object.keys(driverTips).length > 0){
            dispatch({type: 'Driver_Tips_Update', payload: {driver_tips: driverTips}})

            console.log('driver_tips updated again', driverTips)
        }
        
    }, [driverTips])

    useEffect(()=>{
        console.log("in coords hook with coords: " + coords  + " and pax_id " + passenger_id + " loc granted " + location_granted)
        if(location_granted && passenger_id != "" && coords && coords.length > 0) { 
            const pax_lat = coords[0]
            const pax_long = coords[1]
            // The join grace counts from the first write's server answer (ack or rejection).
            const settled = () => setLocationWriteAt(at => at ?? Date.now())

            db.collection('Users').doc(uid).update({
                // ['currentSession.location.pax_latitude'] : latitude,
                // ['currentSession.location.pax_longitude']: longitude,
                // ['currentSession.location.pax_update_time']: firebase.firestore.FieldValue.serverTimestamp(),
                // ['currentSession.location.pax_accuracy']: position.coords.accuracy,
                ['live_pax_coords.'+passenger_id+'.latitude'] : pax_lat,
                ['live_pax_coords.'+passenger_id+'.longitude'] : pax_long,
                ['live_pax_coords.'+passenger_id+'.pax_update_time']: firebase.firestore.FieldValue.serverTimestamp(),
                // ['live_pax_coords.'+passenger_id+'.pax_accuracy']: position.coords.accuracy,
            }).then(settled, (error) => {
                console.log("live_pax_coords write failed", error)
                settled()
            })
        }else{
            console.log("no pax id yet in locsuccess " + passenger_id)
        }
    }, [passenger_id, coords, location_granted])

    //update unique_pax : [passenger_id]
    useEffect(()=>{
        if(passenger_id != "" && uid != "") { 
            db.collection('Users').doc(uid).update({
                'unique_pax' : firebase.firestore.FieldValue.arrayUnion(passenger_id),
                // ['live_pax_coords.'+passenger_id+'.pax_accuracy']: position.coords.accuracy,
            })
            console.log("pax id " + passenger_id + " updated for driver " + uid)
        }else{
            console.log("no pax id yet in locsuccess " + passenger_id)
        }
    }, [passenger_id, uid])

    //current playing hook
    useEffect(() => {
        if (trackName != prev_song) {
            // console.log('prev song', prev_song)
            // console.log('current song', trackName)
            dispatch({ type: "Song_Update", payload: { song: trackName } });
            dispatch({ type: "CDN_update", payload: { cdn: CDN } });
            dispatch({ type: "Artist_update", payload: { artist: artist_name } });
            dispatch({ type: "URL_update", payload: { url: track_url } });
            dispatch({ type: "Increment" });

        }
    }, [trackName])

    //reset on sesh ended hook
    useEffect(() => {
		//reset prev_song ready for next start of sesh
		if(!status){
			dispatch({ type: "Song_Update", payload: { song: "finished" } });
		}
        if(last_queued_song != ""){
            dispatch({ type: "Queued_Song_Update", payload: {last_queued_song: last_queued_song}})
        }
    }, [status, last_queued_song])

    useEffect(() => {
        let unsubscribe;
        if (uid != "") {
            // React 17 renders each setState outside its own events separately: batch the snapshot
            // so presence and the visit log never run against a half-applied driver doc.
            unsubscribe = db.collection('Users').doc(uid).onSnapshot(snapshot => unstable_batchedUpdates(() => {
                if (!snapshot.exists) return;
                // const driver_pax_proximity = snapshot.data().currentSession.location.driverProximity
                // const pax_proximity = snapshot.data().currentSession.location.proximity

                // setDriverPaxProximity(driver_pax_proximity)
                // setPaxProximity(pax_proximity)

                setSnapshots(snapshots+1)
                setUserStatus(snapshot.data().isSessionActive);
                setName(snapshot.data().fullName);
                setStart(snapshot.data().lastCuratedOnUnix)
                const lookup = ++sessionLookup.current
                const curated = snapshot.data().lastCuratedOnUnix
                resolveSessionDocId(snapshot.data(), { db, uid }).then((id) => {
                    if (lookup !== sessionLookup.current) return
                    setSessionDoc((prev) => (prev.start === curated && prev.id === id) ? prev : { start: curated, id })
                })
                setRefreshToken(snapshot.data().spotifyData.access_token)
                setOGIDX(snapshot.data().currentSession.og_idx)
                setQueueIDX(snapshot.data().currentSession.pax_queued_idx)
                
                const latt = snapshot.data().currentSession.location.latitude
                const longg = snapshot.data().currentSession.location.longitude
                const accuracy = snapshot.data().currentSession.location.accuracy
                setDriverLong(longg)
                setDriverLat(latt)
                setDriverAccuracy(accuracy)
                // const driver_pax_proximity = snapshot.data().config.enablePaxRemote
                console.log('states driver prox ' + driverPaxProximity + " , lat " + latt + " and pax_queue_control " + snapshot.data().config.enablePaxQueueing + " on snapshot " + snapshots)

                setDriverPaxQueue(snapshot.data().config.enablePaxQueueing ?? true)
                setDriverPaxVolume(snapshot.data().config.enablePaxVolControl ?? true)

                const curr_cdn = snapshot.data().currentSession.currentTrack.coverArt
                const curr_song = snapshot.data().currentSession.currentTrack.trackName;
                const artistName = snapshot.data().currentSession.currentTrack.artistName;
                const url = snapshot.data().currentSession.currentTrack.url+"?utm_campaign=com.app";
                                
                setAlias(snapshot.data().remoteAlias || "your driver")

                setLastQueued(snapshot.data().last_queued_song)

                setCDN(curr_cdn)
                setArtistName(artistName)
                setTrackURL(url)
                setTrackName(curr_song) // set song last so other curr_* states are updated before redux callback

                if(snapshot.data() && snapshot.data().live_pax_coords){
                    setLivePax(snapshot.data().live_pax_coords)
                    console.log("found num of live pax ", Object.keys(live_pax))
                    console.log("found num of live pax ", Object.keys(snapshot.data().live_pax_coords))
                    
                }else{
                    console.log("NO LIVE PAX COOREDS IN DB YET")
                }
                setDriverDocLoaded(true)
                

                

                if(snapshot.data() && snapshot.data().tipHandle){
                    setDriverTips(snapshot.data().tipHandle)
                    // console.log("set queue from db")
                }else{
                    console.log("NO DRIVER TIPS SETUP IN DB YET")
                }

                if(snapshot.data() && snapshot.data().pax_queue){
                    setPaxQueue(snapshot.data().pax_queue)
                    // console.log("set queue from db")
                }else{
                    console.log("NO PAX QUEUE DOC IN DB YET")
                }
            }))
        }else{
            getDriverUID(qr_id)
            console.log("got driver uid")
        }
        // 

        if (uid!= ""){
            let watcher = null
            var heartbeat = null
            console.log("before geo start")

            if (!navigator || !navigator.geolocation) {
                console.log("GG location not supported/requested")
                return
            } else {
                console.log("location good to go")

                // either use watcher or subscribe to firestore and fetch location on driver coord change by X mi.
                // watcher = navigator.geolocation.watchPosition(locSuccess, locError, geoSettings);

                // Pushes now, every 20 s while visible, and on return to the page.
                heartbeat = startLocationHeartbeat(() => navigator.geolocation.getCurrentPosition(locSuccess, locError, geoSettings));
                heartbeatRef.current = heartbeat
            }

            // SYNC COOKIES only once per pax 
            if (passenger_id == "" && (passenger_id_cookie == "")){
                const tmp_pax_id = getPassengerFingerprint();
                if(guest_pax_name==""){
                    var tmp_guest = fetch_guest_name()
                    setCookie('guest_pax_name', tmp_guest, { path: '/' });
                }

                
                tmp_pax_id.then((pax_id)=>{
                    setCookie('passenger_id', pax_id, { path: '/' });
                    console.log("pax id cookie set ", passenger_id)
                    try {
                        // db.collection('Users').doc(uid).update({
                        //     all_pax : firebase.firestore.FieldValue.arrayUnion(pax_id),
                        //     passengerRequest: "none",
                        //     live_pax : firebase.firestore.FieldValue.arrayUnion(pax_id),

                        //     //if doc doesnt exist already, then reset pax queue?
                        // })
                        console.log("driver doc updated w/ pax", pax_id)
                        setPassengerID(pax_id) 

                    }catch (e){
                        console.log(e)
                    }
                })
            }else if (passenger_id_cookie && passenger_id_cookie != ""){
                setPassengerID(passenger_id_cookie) 
                // db.collection('Users').doc(uid).update({
                //     all_pax : firebase.firestore.FieldValue.arrayUnion(passenger_id_cookie),
                //     passengerRequest: "none",
                //     live_pax : firebase.firestore.FieldValue.arrayUnion(passenger_id_cookie),

                //     //if doc doesnt exist already, then reset pax queue?
                // })
                console.log("passenger_id set from cookie ", passenger_id)

            }

            var unix_rn = Date.now() / 1000
            if(session_id_cookie == ""){
                console.log("sesh COOKIE", session_id_cookie)
                unix_rn = Date.now() / 1000
                setCookie("session_id", unix_rn, {path : '/', expires: new Date(Date.now()+1200000)}) //for frequent refreshes to map to same session_id

            }else{
                console.log("CACHED sesh COOKIE", session_id_cookie)
                unix_rn = session_id_cookie
            }
            dispatch({ type: "session_id_update", payload: { session_id: unix_rn+""} });
            setPaxSeshID(unix_rn+"")
            
        }

        // return () => watcher && navigator.geolocation.clearWatch(watcher);
        return () => {
            if (unsubscribe) unsubscribe();
            if (heartbeat) {
                console.log("geo heartbeat stopped")
                heartbeat.stop();
                heartbeatRef.current = null
            }
          };

    }, [uidFetched]);

    // No location cadence while the session is inactive; resumes the moment it starts.
    useEffect(() => {
        if (heartbeatRef.current) heartbeatRef.current.setActive(Boolean(status))
    }, [status])


    // Per pax hook
    useEffect(()=>{
        if(passenger_id != "" && Object.keys(live_pax).length > 0){
            const pax_keys = Object.keys(live_pax)
            if(passenger_id in live_pax){ // can also use pax_keys.hasOwnProperty(passenger_id) for pax's FIRST geo push
                const pax_coord_data = live_pax[passenger_id]
                console.log("live pax updated and " + passenger_id + " found from pax proximity hook w/ live_pax " + JSON.stringify(live_pax, null, 2))

                if("queue_delay" in pax_coord_data) {
                    console.log("FOUND QUEUEDELAY IN DB as, ", pax_coord_data["queue_delay"])
                    setCircleDelayDB(Boolean(pax_coord_data["queue_delay"]))
                }else{
                    setCircleDelayDB(false)
                }

                if("pax_preferences" in pax_coord_data) {
                    console.log("FOUND PAX_PREFS IN DB as, ", pax_coord_data["pax_preferences"])
                    dispatch({type: 'Pax_Prefs', payload: {preferences: pax_coord_data["pax_preferences"]}})

                }

                if("driver_secret" in pax_coord_data && !("expired" in pax_coord_data)){
                    // const secret_granted_time = new Date(pax_coord_data["secret_granted_time"]._seconds * 1000)
                    const secret_granted_time = (pax_coord_data["secret_granted_time"].toDate())

                    //TODO: Add driver secret timeout by comparing clientside time accessed VS time secret granted!!
                    console.log("pax secret assigned on date " + secret_granted_time)
                    setDriverPaxProximity(Boolean(pax_coord_data["driver_secret"]))

                }else if("expired" in pax_coord_data){ //outdated pax data after pax exits still in live_pax
                    console.log("pax " + passenger_id + " sadly expired driver secret ")
                    setDriverPaxProximity(false)
                }
                
                if(pax_guest_name == "" && !pax_redux_refresh){
                    var tmp_guest = fetch_guest_name()
                    setPaxGuestName(tmp_guest)
                    console.log("guest pax_name set instead to " + tmp_guest)
        
                    setCookie('pax_name', '', { path: '/' });
                    setCookie('guest_pax_name', tmp_guest, { path: '/' });
                }
                
            }else{
                console.log("ios geo manager REMOVED pax id " + passenger_id + " in live_pax")
            }
        }else{
            console.log("NOT FINDING ANY live_pax since empty")
        }
    }, [live_pax, passenger_id])


    const [passengerReady, setPassengerReady] = useState('');
    const [visitError, setVisitError] = useState('');
    const [connectionAttempt, setConnectionAttempt] = useState(0);
    const visitorId = passenger_id || passenger_id_cookie;
    // A joining rider is not geofence-locked: log the visit once presence is known.
    const visitKey = visitorId && uid && pax_sesh_id && start > 0 && presence.view !== PRESENCE_VIEW.CONNECTING
        ? JSON.stringify([visitorId, uid, pax_sesh_id, start]) : '';
    const visitLocationGranted = Boolean(location_granted || location_granted_cookie);
    const visitHasProximity = presence.view === PRESENCE_VIEW.REMOTE;
    const visitRecheck = inLockGrace(presence.view);

    // Auth can return before fingerprint/session initialization finishes. Wait for
    // both visit documents to commit, then save the verified Spotify connection.
    useEffect(() => {
        let active = true;
        setPassengerReady('');
        setVisitError('');
        if (!visitKey) return;
        initializePassengerVisit(db, {
            passengerId: visitorId, passengerSessionId: pax_sesh_id,
            driverUid: uid, driverSessionStart: start,
            locationGranted: visitLocationGranted, hasProximity: visitHasProximity, recheck: visitRecheck,
        }).then(() => {
            if (active) setPassengerReady(visitKey);
        }, () => {
            if (active) setVisitError('Couldn’t save your visit. Try again.');
        });
        return () => { active = false; };
    }, [visitKey, visitorId, uid, pax_sesh_id, start, visitLocationGranted, visitHasProximity, visitRecheck, connectionAttempt]);

    const spotifyConnection = useSpotifyConnection({
        passengerId: visitorId, passengerSessionId: pax_sesh_id,
        ready: Boolean(visitKey) && passengerReady === visitKey,
        attempt: connectionAttempt,
    });
    const connectionError = visitError || spotifyConnection.error;
    const connectionNotice = connectionError && (
        <div className="connection-notice" role="alert">
            <span>{connectionError}</span>
            {!visitError && (!cookies.access_token || !cookies.refresh_token || cookies.access_token === 'NO_ACCESS' || cookies.refresh_token === 'NO_REFRESH') ? (
                <a href="https://remote.strive.fm/spotify_login">Connect again</a>
            ) : (
                <button type="button" onClick={() => setConnectionAttempt(value => value + 1)}>Try again</button>
            )}
        </div>
    );

    //CALLBACK TO UPDATE THE TRACKS THAT PAX IS ACTIVELY EXPOSED ON QR FOR IN STRIVER.SESH.TRACKS
    useEffect(()=>{
        var pax_id = ""
        if(passenger_id !=""){ 
            pax_id = passenger_id
        }else if (passenger_id_cookie && passenger_id_cookie != ""){
            pax_id = passenger_id_cookie
        }


        const sessionRef = sessionDocRef(db, uid, sessionDocId)
        if(track_url!="" && pax_id && pax_id !="" && uid!="" && pax_sesh_id!="" && sessionRef && og_idx!=-1 && pax_queued_idx!=-1){ //session_id is unix
            console.log("updating pax " + pax_id + " for session " + pax_sesh_id + "with driver_sesh " + sessionDocId + "on og_idx " + og_idx + " & pax queued idx " + pax_queued_idx)
            var curr_track_parts = track_url.split("/") 
            var curr_track_id_utm = curr_track_parts[curr_track_parts.length - 1]
            var curr_track_id_parts = curr_track_id_utm.split("?")
            var curr_track_id = curr_track_id_parts[0]
            
            var curr_track_doc_ = curr_track_id+"_"+ ( og_idx - pax_queued_idx)
            //STILL USING track_OGIDX INSTEAD OF track_REPEATNUM to update session.tracks
            //TODO: store currentSession.currentTrack.campaign_id and if campaign_id== "BOT" && genres[0] == "pax_perso" then update pax_tracks since pax queued
            sessionRef.collection("tracks").doc(curr_track_doc_).update({
                'pax_active' : firebase.firestore.FieldValue.arrayUnion({
                    'pax_id': passenger_id,
                    'session_id' : pax_sesh_id,
                }),
            })
        }
    }, [passenger_id, uid, pax_sesh_id, sessionDocId, track_url, og_idx, pax_queued_idx])


    useEffect(()=>{
        console.log("prox changed to "+ paxProximity + " and driverpaxprox to " +driverPaxProximity)
    }, [paxProximity, driverPaxProximity])

    // Same screen as a denial, rendered here so the heartbeat keeps running: the next fix
    // restores the remote. Its retry is a beat, so a failure never clears the cookie.
    if (locationHelpDue(locationMisses)) {
        const retryLocation = () => {
            setLocationRetrying(true)
            navigator.geolocation.getCurrentPosition(locSuccess, locError, geoSettings)
        }
        return <JoinScreen denied pending={locationRetrying} onConnect={retryLocation}
            error={locationRetrying ? '' : 'Your location is unavailable right now. The remote comes back on its own once location works again.'} />;
    }

    const canUseRemote = showsRemote(presence.view);
    if(status && canUseRemote){
        return (
            <div className='dark-container'>
                <Navbar uid={uid} qr_id={qr_id} active={status} driver_name={name} driver_alias={alias} passenger={passenger_id} live_pax={live_pax}/>
                {connectionNotice}
                {presence.view === PRESENCE_VIEW.RECHECKING && <PresenceRecheckNotice />}
                <RemoteTabs live_pax={live_pax} qr_id={qr_id} uid={uid} active={status} passenger={passenger_id} driver_pax_proximity={driverOverride} pax_proximity={paxProximity} pax_access={pax_access_cookie} driver_access={refreshToken} start={sessionDocId} idx={og_idx} queued_idx={pax_queued_idx} queue_control={driverPaxQueue} vol_control={driverPaxVolume} circle_delay={circle_delay} driver_tips={driverTips} pax_sesh_id={pax_sesh_id}/>
                <Remote uid={uid} passenger={passenger_id} refresh={refreshToken} vol_control={driverPaxVolume}/>
            </div>
    )
    }else if (status && presence.view === PRESENCE_VIEW.ENDED){
        return (
            <div className='dark-container'>
                {connectionNotice}
                <RideEnded uid={uid} alias={alias} active={status} driver_name={name} passenger={passenger_id} pax_proximity={paxProximity} driver_pax_proximity={driverPaxProximity} pax_access={pax_access_cookie} driver_access={refreshToken} start={sessionDocId} idx={og_idx}/>
            </div>
        );
    }else if (status){
        return <PresenceCheck />;
    }else{
        return (
        <div className='dark-container'>
            {connectionNotice}
            <Inactive alias={alias} uid={uid} active={status} driver_name={name} passenger={passenger_id} start={sessionDocId} idx={og_idx}/>
        </div>
        );
    }
}

export default Lookup;
